export const noOfTxnsOptions = [
  { label: "1 - 100", value: "1 - 100" },
  { label: "100 - 500", value: "100 - 500" },
  { label: "500 - 1000", value: "500 - 1000" },
  { label: "1000 - above", value: "1000 - above" },
];

export const valueOfTxnsOptions = [
  { label: "$1 - $1000", value: "$1 - $1000" },
  { label: "$1001 - $10,000", value: "$1001 - $10000" },
  { label: "$50,001 - $100,000", value: "$50001 - $100000" },
  { label: "$100,001 - $500,000", value: "$100001 - $500000" },
  { label: "$500,001 - $1,000,000", value: "$500001 - $1000000" },
  { label: "$1,000,001 - $10,000,000", value: "$1000001 - $10000000" },
  { label: "above $10,000,000", value: "above $10000000" },
];

export const polarResponse = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

type DocumentType = {
  id: string;
  title: string;
  description: string;
  path: string;
  isRequired: boolean;
  photographId?: string;
  identityId?: string;
  proofOfAddressId?: string;
};

export const listOfDirectorsDocuments: DocumentType[] = [
  {
    id: "id",
    title: "Identification Document",
    description:
      "This should be a government issued ID such as a driver's license or international passport, with at least 6 months validity period.",
    path: "director-id",
    isRequired: true,
    identityId: "Director and owner valid ID",
  },
  {
    id: "address",
    title: "Proof of Address",
    description: "This proves your ultimate beneficial owner's address and can be a utility bill (electricity, waste management, water, gas, or cable TV like DSTV) issued within the last 3 months.",
    path: "director-or-trustee-proof-of-address",
    isRequired: true,
    proofOfAddressId: "Director/Trustee Proof of Address"
  }
];

export const documentSections = [
  {
    title: "Proof of business address",
    description:
      "This proves your business address and can be a utility bill (electricity, waste management, water, gas, or cable TV like DSTV) issued within the last 3 months.",
    componentId: 6,
    path: "proof-of-address",
    isRequired: true,
  },
  {
    title: "Operating License",
    description:
      "Upload any relevant operating license obtained related to your business industry.",
    componentId: 44,
    path: "account-statement",
    isRequired: true,
  },
  {
    title: "Certificate of Incorporation",
    description:
      "An official document confirming your business is legally registered as a company.",
    componentId: 10,
    path: "certificate-of-incorporation",
    isRequired: true,
  },
  {
    title: "Memorandum and Articles of Association",
    description:
      "A legal document outlining your company’s purpose, structure, and operational rules.",
    componentId: 12,
    path: "memorandum-articles-of-association",
    isRequired: true,
  },
  {
    title: "Business Name Registration Certificate",
    description:
      "A certificate verifying the registration of your business name with the appropriate authority.",
    componentId: 14,
    path: "business-name-reg-cert",
    isRequired: true,
  },
  {
    title: "CAC Status Report",
    description:
      "An official report from the Corporate Affairs Commission detailing your company’s registration status.",
    componentId: 11,
    path: "cac-status-report",
    isRequired: true,
  },
  {
    title: "Registered Aims and Objectives",
    description:
      "A document stating the primary goals and objectives of your registered business or organization.",
    componentId: 48,
    path: "registered-aims-objectives",
    isRequired: true,
  },
  {
    title: "CAC Application Form",
    description:
      "A completed form submitted to the Corporate Affairs Commission during the company registration process.",
    componentId: 15,
    path: "cac-application-form",
    isRequired: true,
  },
  {
    title: "Constitution/Board Charter",
    description:
      "Provide your Constitution/Board Charter. Ensure it is complete, and includes the business name.",
    componentId: 50,
    path: "constitution-board-charter",
    isRequired: true,
  },
  {
    title: "Incorporated Documents",
    description:
      "An official document confirming your business is legally registered as a company.",
    componentId: 51,
    path: "incorporated-documents",
    isRequired: true,
  },
  {
    title: "Tax Pin Certificate",
    description: "Upload your tax clearance certificate.",
    componentId: 52,
    path: "tax-pin-certificate",
    isRequired: true,
  },
  {
    title: "Tax Identification Certificate",
    description: "Upload your tax clearance certificate.",
    componentId: 53,
    path: "tax-identification-certificate",
    isRequired: true,
  },
  {
    title: "Registration Certificate & Sole Proprietorship profile (Form A)",
    description:
      "An official document confirming your business is legally registered as a company.",
    componentId: 54,
    path: "registration-certificate-sole-proprietorship-profile",
    isRequired: true,
  },
  {
    title: "KRA Tax Certificate or Copy of CR12",
    description: "Valid certificate within 30 days.",
    componentId: 45,
    path: "kra-tax-certificate",
    isRequired: true,
  },
];
